import ApiService from '../../../common/ApiCalls'
import {
  consumerDataFetch,
  consumerDataFetchSuccess,
  consumerDataFetchFailure,
  providerDataFetch,
  providerDataFetchSuccess,
  accountDetailFetch
} from './actions'

const listener = {
  [consumerDataFetch]: async (action, dispatch) => {
    const id = action.payload.id
    const tabName = action.payload.tabName

    const requestArray = []

    requestArray.push(ApiService().getAsset(id))
    requestArray.push(ApiService().getTabView(id, tabName))
    requestArray.push(ApiService().getAllFieldTypes())

    switch (tabName) {
      case 'tab0': //locaiton
        requestArray.push(ApiService().getAsset(id))
        break
      case 'tab1': // people
        requestArray.push(ApiService().getAsset(id))
        break
      case 'tab2': //service
        requestArray.push(ApiService().getAsset(id))
        break
      case 'tab3': //account
        //nada until accountId comes back with the first request
        break
      case 'tab4': //dashboard
        requestArray.push(ApiService().getDashboardData(id))
        break
      case 'tab5': //dashboard data
        requestArray.push(
          ApiService().getPaginatedDashboardData(id, null, null, 1, 50)
        )
        requestArray.push(
          ApiService().getPaginatedComments(id, null, null, 1, 50)
        )
        requestArray.push(ApiService().getCommenterTypes())
        break
      default:
        throw new Error('unknown tab type')
    }

    Promise.all(requestArray)
      .then(async data => {
        const location = data[0]
        const obj = formatApiViewData(data[1]) // field metadata must go through a bunch of transofrmations
        const cardList = obj.finalArray
        const fieldList = obj.fieldValueList
        const fieldTypeList = data[2]
        let contactList,
          serviceList,
          categorizedServiceList,
          dashboardData,
          paginatedDashBoardData,
          paginatedComments,
          commenterTypes,
          assets,
          owner,
          primary

        switch (tabName) {
          case 'tab0': //locaiton
            //nada
            break
          case 'tab1': // people
            contactList = data[3].party_ids
            break
          case 'tab2': //service
            //serviceList = data[3].service_ids
            let temp = await createLegacyServiceList(data[3].service_ids)

            serviceList = temp[0].data[0].service_details

            categorizedServiceList =
              categorizeServicesByServiceType(serviceList)

            break
          case 'tab3': //account
            const entityId = location.entity_id
            const entityDetail = await ApiService().getEntity(entityId)
            assets = await ApiService().listAssetsByEntityId(entityId)
            owner = await ApiService().getPartyById(entityDetail.owners[0].id)
            primary = await ApiService().getPartyById(entityDetail.contacts[0].id)
            dispatch(accountDetailFetch(entityId))
            break
          case 'tab4': //dashboard
            dashboardData = data[3]
            break
          case 'tab5': //dashboard data
            paginatedDashBoardData = data[3]
            paginatedComments = data[4]
            commenterTypes = data[5]
            break
          default:
            throw new Error('unknown tab type')
        }
        dispatch(
          consumerDataFetchSuccess({
            location,
            fieldTypeList,
            cardList,
            fieldList,
            contactList,
            serviceList,
            categorizedServiceList,
            dashboardData,
            paginatedDashBoardData,
            paginatedComments,
            commenterTypes,
            tabName,
            assets,
            owner,
            primary
          })
        )
      })
      .catch(e => {
        console.log(e)
        dispatch(consumerDataFetchFailure(e))
      })
  },

  [providerDataFetch]: async (action, dispatch) => {
    const tabName = action.payload.tabName
    ApiService()
      .getTabLayout(tabName)
      .then(res => {
        const returnVal = formatApiLayoutData(res) // field metadata must go through a bunch of transofrmations

        const metaList = returnVal.data
        const defaultData = returnVal.defaultData

        dispatch(
          providerDataFetchSuccess({
            metaList,
            defaultData
          })
        )
      })
      .catch(e => {
        console.log(e)
        dispatch(consumerDataFetchFailure(e))
      })
  }
}

const createLegacyServiceList = async serviceIds => {
  const serviceTypes = await ApiService().listServiceTypes()

  if (serviceIds.length > 0) {

  //Same as for partys I will be recreating the array from the old api as a temporary solution
        
  var serviceArray = [{'data' : [{'service_details' : [], 'field_details' : [] }]}]
        
  for (var i = 0; i < serviceIds.length; i++)
  {
  const service = await ApiService().getServicesById(serviceIds[i])
  var type = ''
        
  for (var j = 0; j < serviceTypes.length; j++)
  {
    if (service.type_id === serviceTypes[j].id) { type = serviceTypes[j].name }
    }
        
      serviceArray[0].data[0].service_details.push({
        'id': service.id,
        "name": service.name,
        "description": service.description,
        "email": service.email,
        "phone": service.phone,
        "document_url_name": null,
        "type_id": service.type_id,
        "category_id": service.category_id,
        "created_at":service.created_at,
        "updated_at": service.updated_at,
        "suspended_at": service.suspended_at,
        "deleted_at": service.deleted_at,
        "bec_service_id": "",
        "last_modified": null,
        "service_type_id": service.type_id,
        "service_type": type,
        "deleted": 0
      })
    }

    return serviceArray
  }
  return null
}

const categorizeServicesByServiceType = categoriesArray => {
  let categorizedServicesObjectByServiceType = {}
  for (let i = 0; i < categoriesArray.length; i++) {
    if (
      categorizedServicesObjectByServiceType[categoriesArray[i].service_type]
    ) {
      categorizedServicesObjectByServiceType[
        categoriesArray[i].service_type
      ].push(categoriesArray[i])
    } else {
      categorizedServicesObjectByServiceType[categoriesArray[i].service_type] =
        [categoriesArray[i]]
    }
  }
  return categorizedServicesObjectByServiceType
}

const formatApiViewData = res => {
  let cardsObj = {}
  const fieldValueList = []
  for (let i = 0; i < res.length; i++) {
    const {
      card_custom_is_archived: isArchived,
      card_custom_is_hidden: isHidden,
      card_custom_is_mandatory: isMandatory,
      card_custom_name: label,
      card_custom_position: position,
      card_custom_type: type,
      card_id: cardId,
      card_sys_name: cardSysName,
      data: fieldData,
      field_custom_is_archived: fieldIsArchived,
      field_custom_is_hidden: fieldIsHidden,
      field_custom_is_mandatory: fieldIsMandatory,
      field_custom_name: fieldLabel,
      field_custom_position: fieldPosition,
      field_custom_type: fieldType,
      field_id: fieldId,
      field_sys_name: fieldSysName,
      service_data: serviceData,
      service_id: serviceId
    } = res[i]

    // field_value management for each service

    fieldValueList.push({
      fieldId: fieldId,
      serviceData: serviceData,
      serviceId: serviceId,
      fieldType: fieldType
    })

    if (!cardsObj[cardId]) {
      cardsObj = {
        ...cardsObj,
        [cardId]: {
          cardId,
          label,
          sysName: cardSysName,
          position,
          type,
          isArchived,
          isHidden,
          isMandatory,
          cardData: []
        }
      }
    }

    const data = () => {
      if (
        type === 'Multiple Columns Data List' &&
        (fieldData === undefined || fieldData === ' ')
      ) {
        const numberOfColumns = JSON.parse(label).length
        return Array(numberOfColumns - 1).fill('')
      }
      return fieldData
    }

    cardsObj[cardId].cardData[fieldPosition] = {
      fieldId,
      label: fieldLabel,
      sysName: fieldSysName,
      position: fieldPosition,
      type: fieldType,
      isMandatory: fieldIsMandatory,
      isHidden: fieldIsHidden,
      isArchived: fieldIsArchived,
      fieldData: data(),
      serviceData: serviceData,
      serviceId: serviceId
    }
  }

  let finalArray = []
  const cardIdArray = Object.keys(cardsObj)

  for (let i = 0; i < cardIdArray.length; i++) {
    const targetObj = cardsObj[cardIdArray[i]]

    const cardTempArray = []
    for (let j = 0; j < targetObj.cardData.length; j++) {
      targetObj.cardData[j] && cardTempArray.push(targetObj.cardData[j])
    }
    targetObj.cardData = cardTempArray
    finalArray[targetObj.position] = targetObj
    targetObj.cardData = targetObj.cardData.filter(n => n)
  }
  finalArray = finalArray.filter(n => n)
  return { finalArray, fieldValueList }
}

const formatApiLayoutData = res => {
  const cardsObj = { data: {}, defaultData: {} }
  for (let i = 0; i < res.length; i++) {
    const {
      card_default_is_hidden: isHiddenCardDefault,
      card_default_name: labelCardDefault,
      card_default_position: positionCardDefault,
      card_id: cardId,
      card_type: typeCard,
      field_default_is_archived: isArchivedFieldDefault,
      field_default_is_hidden: isHiddenFieldDefault,
      field_default_is_mandatory: isMandatoryFieldDefault,
      field_default_name: labelFieldDefault,
      field_default_position: positionFieldDefault,
      field_id: fieldId,
      card_custom_is_hidden: isHiddenCardCustom,
      card_custom_name: labelCardCustom,
      card_custom_position: positionCardCustom,
      field_custom_is_archived: isArchivedFieldCustom,
      field_custom_is_hidden: isHiddenFieldCustom,
      field_custom_is_mandatory: isMandatoryFieldCustom,
      field_custom_name: labelFieldCustom,
      field_custom_position: positionFieldCustom,
      field_custom_type: typeFieldCustom
    } = res[i]
    if (!cardsObj.data[cardId]) {
      cardsObj.data[cardId] = {
        cardId,
        label: labelCardCustom,
        position: positionCardCustom,
        type: typeCard,
        isHidden: isHiddenCardCustom,
        cardData: []
      }
    }

    cardsObj.data[cardId].cardData[positionFieldCustom] = {
      fieldId,
      label: labelFieldCustom,
      position: positionFieldCustom,
      type: typeFieldCustom,
      isMandatory: isMandatoryFieldCustom,
      isHidden: isHiddenFieldCustom,
      isArchived: isArchivedFieldCustom
    }

    if (!cardsObj.defaultData[cardId]) {
      cardsObj.defaultData[cardId] = {
        cardId,
        label: labelCardDefault,
        position: positionCardDefault,
        type: typeCard,
        isHidden: isHiddenCardDefault,
        cardData: []
      }
    }

    cardsObj.defaultData[cardId].cardData[positionFieldDefault] = {
      fieldId,
      label: labelFieldDefault,
      position: positionFieldDefault,
      type: typeFieldCustom,
      isMandatory: isMandatoryFieldDefault,
      isHidden: isHiddenFieldDefault,
      isArchived: isArchivedFieldDefault
    }
  }

  const finalObj = { data: [], defaultData: [] }

  const cardIdArray = Object.keys(cardsObj.data)
  for (let i = 0; i < cardIdArray.length; i++) {
    const targetDataObj = cardsObj.data[cardIdArray[i]]
    finalObj.data[targetDataObj.position] = targetDataObj
    const targetDefaultDataObj = cardsObj.defaultData[cardIdArray[i]]
    targetDefaultDataObj.cardData = targetDefaultDataObj.cardData.filter(n => n)

    finalObj.defaultData[targetDefaultDataObj.position] = targetDefaultDataObj
  }
  return finalObj
}

export default listener
